<template>
  <!-- 停車場容留 -->
  <div class="col mt-3">

    <div class="card card-clean h-100 mt-3">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        停車場容留
      </div>
      <div class="card-body px-2 text-center">
        <!-- <div style="margin:auto;max-width:450px" class="mb-2">
          <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
        </div> -->
        <div class="container ">
          <div class="row d-flex flex-wrap  mt-3 mb-5 ">
        
            <div class=" col-sm-4 col-12 mb-2 p-2  block-type" :class=" countTotalParkingRateCSS()">
              <p class="mb-2" :class=" countTotalParkingRateCSS()">總容留率</p> 
              <p class="mb-0 fs-4" :class=" countTotalParkingRateCSS()">
                {{this.countTotalParkingRate()}} %
              </p>
            </div>
           <div class="  col-sm-8  col d-flex  flex-wrap p-0 mb-0 text-nowrap">
            <div class="col mb-2 p-2 block-type  mx-1">
             <p class="mb-2">大客車  <i class="fas fa-parking"></i></p> 
            
              <p class="mb-2 ">
                餘 <strong class="strong-indigo">{{ this.allVehicleFlow.busParkingSpace - this.allVehicleFlow.busInSiteFlow }}</strong>/{{this.allVehicleFlow.busParkingSpace}}
                
              </p>
            </div>

            <div class=" col mb-2 p-2 block-type me-1">
              <p class="mb-2">小客車  <i class="fas fa-parking"></i></p>
              <p class="mb-2 ">
               餘 <strong class="strong-indigo">{{ this.allVehicleFlow.carParkingSpace - this.allVehicleFlow.carInSiteFlow }}</strong>/{{this.allVehicleFlow.carParkingSpace}}
              </p>
            </div>
            
            <div class="col mb-2 p-2 block-type ">
              <p class="mb-2">機車  <i class="fas fa-parking"></i></p>
              <p class="mb-2">
               餘<strong class="strong-indigo"> {{ this.allVehicleFlow.motocycleParkingSpace - this.allVehicleFlow.motocycleInSiteFlow }}</strong>/{{this.allVehicleFlow.motocycleParkingSpace}}
              </p>
            </div>

         
          
          </div>
          <!-- <div class=" mb-4 p-2 block-type" >
              <p class="mb-0">總容留率</p> 
              <p class="mb-0 strong-indigo">
                {{this.countTotalParkingRate()}} %
              </p>
            </div> -->
        </div>
        
        <div class="chart-description chart-description-btm  mt-5">
          各車種當日即時在園停車容留資訊。
          <div class="chart-description-sm ">
          【註】 停車容留率計算方式 = （進入車數 - 離場車數）÷ 停車位
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
    
<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
const zh_tw = require("../../utils/apexchartObject/apexLocales/zh-tw.json");
export default {
  props: ['selectedScenicAreaId'],
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {

      series: [], // 這裡的數值根據你的資料來填寫
      chartOptions: {
        colors: CONST.APEXCHART_COLOR.LINE_CHART_RANGE,
        chart: {
          stacked: true,
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
            export: {
              csv: {
                filename:this.selectedScenicAreaId+"custom_csv"+moment,
              },
              svg: {
                filename: "custom_svg",
              },
              png: {
                filename: "custom_png",
              }
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            // distributed: true
            colors: {
              // backgroundBarColors: ["#8baded"], // 使用淺藍色為背景色
              // backgroundBarOpacity: 1, // 設定背景顏色的透明度
              // ranges: [
              //   { from: 0, to: 0.8, color: "#5db2fa" }, // 80%以下為綠色
              //   { from: 0.8, to: 0.9, color: "#ffa94e" }, // 80~90%為橘色
              //   { from: 0.9, to: 1, color: "#ff7676" }, // 90%以上為紅色
              // ],
            },

          },
        },
        // xaxis: {
        //   // categories: [], // 停車場名稱 測試資料
        //   labels: {
        //     formatter: function (value) {
        //       return Math.round(value * 100) + "%"; // 將x軸的小數值轉換為百分比
        //     },
        //   },
        //   min: 0,
        //   max: 1,
        //   tickAmount: 5,
  
        // },
        states:{
          hover:{
            filter:{
              type: 'none',
            }
          }
        },
        tooltip:{
          style:{
            fontSize:'18px',
          },
          x:{
            show:false
          },
          // y:{
             
          //   formatter: function (val) {
          //     return val*100 + "%"; // 轉換為百分比格式，並四捨五入到小數點後一位
          //   }
          
  
          // }
        },
        legend: {
          // fontSize: "13px",
          // width: 120,
          position:"bottom"
        },
        labels: [ '機車','小客車','大客車'], 
        // colors: {}
      //  [ function ({ value, seriesIndex, w }) {
      //     // let series = w.config.series;
      //     // let total = series.reduce((acc, cur) => acc + cur, 0);
      //     // let rate = value / total;
     
      //     if (value < 0.8) return '#91cc75'
      //     else if (value < 0.9) return '#fabf58'
      //     else if (value >= 0.9) return '#f28188'
      //   }]
      },
      allVehicleFlow:[],
    };
  },
  methods: {
    getScenicAreaData() {
      //console.log(this.vehicleAndPeople)
      //console.log(this.selectedScenicAreaId)
      let vm = this
      let q=this.vehicleAndPeople
      //debugger
      let data = this.vehicleAndPeople.filter(v => v.scenicAreaId == vm.selectedScenicAreaId)[0].vehicleFlowData
      console.log("data",data);

      // let totalParkingNow = data.totalInSiteCarFlow < 0 ? 0 : data.totalInSiteCarFlow;
      // let totalParkingSpace = data.carParkingSpace + data.busParkingSpace ; 


      //為了避免停車率百分比大於 100% ，新增條件若 在園車數 > 停車位，則 在園車數 = 停車位
      // if(totalParkingNow>totalParkingSpace){
      //   totalParkingNow = totalParkingSpace;
      // }
      this.setSpaceLimit(data);
    },

    setSpaceLimit(data){
      //檢查各車種已停總數，若 1.已停車位為負數，則為0 ;  2. 大於停車位總數，則不超過車位總數;
      data.carInSiteFlow= data.carInSiteFlow < 0 ? 0 : data.carInSiteFlow;
      data.motocycleInSiteFlow= data.motocycleInSiteFlow < 0 ? 0 : data.motocycleInSiteFlow;
      data.busInSiteFlow= data.busInSiteFlow < 0 ? 0 : data.busInSiteFlow;
      
      if (data.carInSiteFlow > data.carParkingSpace){
        data.carInSiteFlow = data.carParkingSpace

      }
      if(data.motocycleInSiteFlow > data.motocycleParkingSpace){
        data.motocycleInSiteFlow = data.motocycleParkingSpace
      }
      if(data.busInSiteFlow > data.busParkingSpace){
        data.busInSiteFlow = data.busParkingSpace
      }


      this.allVehicleFlow = data;

    },

    countTotalParkingRate(){
      // 配合儀錶板停車容留計算方式 (大客車容留率 + 小客車容留率)
      // let bData = this.allVehicleFlow.busInSiteFlow /
      //       (this.allVehicleFlow.carParkingSpace +
      //       this.allVehicleFlow.busParkingSpace);

      // let busParkingRate = Math.round(bData*100)/100;
      // if (bData > 1){
      //       bData = 1
      //     };
      // let cData = this.allVehicleFlow.carInSiteFlow /
      //       (this.allVehicleFlow.carParkingSpace +
      //       this.allVehicleFlow.busParkingSpace);
      // if (cData > 1) {
      //      cData = 1
      //   };
 
      const ratio = this.allVehicleFlow.fourWheelParkingUsageRatio 
      const value = ratio > 1 ? 1 : ratio < 0 ? 0 : ratio;

       return Math.floor(value * 100);// 無條件捨去換算後小數點位
      // let carParkingRate = Math.round (cData*100)/100;
      // return (busParkingRate + carParkingRate)*100;
    },

    countTotalParkingRateCSS(){
        if (this.countTotalParkingRate() >=90){
            return "text-white bg-danger "
        } else if (this.countTotalParkingRate() >= 80) {
            return 'text-white bg-orange' ;
        } else {
            return'strong-indigo' ;
        }
  }

    


  },
  computed: {
    vehicleAndPeople() {
      return this.$store.getters['elasticMonitor/getVehicleAndPeople']
    },
    selectedScenicAreaName(){
      return Utils.getSingleScenicAreaNamebyId(this.selectedScenicAreaId)
    }
  },
  watch: {
    vehicleAndPeople() {
      this.getScenicAreaData()
    },
    selectedScenicAreaId() {
      this.getScenicAreaData()
    }
  },
  async mounted() {
    if (this.vehicleAndPeople?.length == 0) {
      await this.$store.dispatch('elasticMonitor/getVehicleAndPeople')
    }
    else {
      this.getScenicAreaData()
    }
  }
};
</script>

<style lang="scss" scoped>
.block-type{

  border-radius: 10px;
  background-color: #ededed;

  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #f2f2f2;

  min-width: 100px;
}


.block-type>p:nth-child(2){
  font-size: 18px;
  
  // color: #f2f2f2;
  
}

.strong-indigo{
  color:var(--bs-indigo);
  // font-size: 18px;
}

.bg-orange{
  background-color: var(--bs-orange) !important;

}
</style>
    